/* Core Reforme: mobile layout helpers */
(function(){
  var mq = window.matchMedia('(max-width: 989px)');
  function placeInbox(){
    var box = document.querySelector('.cr-inbox');
    if (!box) return;
    if (mq.matches) {
      var accs = document.querySelectorAll('.product-accordion');
      var last = accs.length ? accs[accs.length - 1] : null;
      var anchor = last ? (last.closest('.product__block') || last.parentNode) : null;
      if (!anchor) {
        var btns = document.querySelector('.product__submit');
        anchor = btns ? (btns.closest('.product__block') || btns) : null;
      }
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
        box.classList.add('cr-inbox--m');
      }
    } else if (box.classList.contains('cr-inbox--m')) {
      var pi = document.querySelector('product-images');
      if (!pi) return;
      var thumbs = pi.querySelector('product-thumbs');
      if (thumbs && thumbs.nextSibling) pi.insertBefore(box, thumbs.nextSibling); else pi.appendChild(box);
      box.classList.remove('cr-inbox--m');
    }
  }
  function init(){ setTimeout(placeInbox, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (mq.addEventListener) mq.addEventListener('change', placeInbox);
})();

/* Product gallery: lightbox shows only the photos in the gallery (one colour at a time),
   plus a swipe counter on phones */
(function(){
  function fname(u){ return (u || '').split('?')[0].split('/').pop(); }
  function init(){
    var pi = document.querySelector('product-images');
    var slides = pi && pi.querySelector('.product__slides');
    if (!slides) return;

    slides.addEventListener('click', function(e){
      var img = e.target.closest('[data-zoom-image]');
      if (!img || !slides.contains(img) || pi.classList.contains('is-dragging')) return;
      var z = img.parentElement;
      while (z && typeof z.createZoom !== 'function') z = z.parentElement;
      if (!z) return;
      var list = [].slice.call(slides.querySelectorAll('[data-zoom-image]'));
      var i = list.indexOf(img);
      if (i < 0) return;
      e.preventDefault(); e.stopPropagation();
      z.images = list;
      z.createZoom(i);
      if (window.a11y) window.a11y.lastElement = img;
      var th = document.querySelector('.pswp__thumbs');
      if (th) {
        var figs = [].slice.call(th.children);
        var keep = list.map(function(x){
          var n = fname(x.getAttribute('data-image-src'));
          return figs.filter(function(f){ var im = f.querySelector('img'); return im && fname(im.getAttribute('src')) === n; })[0];
        }).filter(Boolean);
        if (keep.length === list.length) { th.innerHTML = ''; keep.forEach(function(k){ th.appendChild(k); }); }
      }
    }, true);

    var wrap = slides.parentNode;
    wrap.classList.add('cr-gal-wrap');
    var count = document.createElement('span');
    count.className = 'cr-gal-count';
    count.setAttribute('aria-hidden', 'true');
    wrap.appendChild(count);
    function update(){
      var items = [].slice.call(slides.children).filter(function(s){ return s.offsetParent !== null; });
      if (items.length < 2) { count.style.display = 'none'; return; }
      var L = slides.getBoundingClientRect().left, best = 0, d = Infinity;
      items.forEach(function(s, k){ var dd = Math.abs(s.getBoundingClientRect().left - L); if (dd < d) { d = dd; best = k; } });
      count.style.display = '';
      count.textContent = (best + 1) + ' / ' + items.length;
    }
    slides.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('theme:media:select', function(){ setTimeout(update, 400); });
    setTimeout(update, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 50); });
  else setTimeout(init, 50);
})();

/* Product page on phones: colour and Add to cart sit right under the photo.
   Order becomes title, price, colour, Add to cart, free gift, description. */
(function(){
  var mq = window.matchMedia('(max-width: 749px)');
  var marks = [];
  function blockOf(el){ return el ? el.closest('.product__block') : null; }
  function apply(){
    var sw = document.querySelector('.product__block variant-selects, .product__block label[data-swatch], .product__block select[name^="options"]');
    var variants = blockOf(sw);
    var buttons = document.querySelector('.product__block--buttons');
    if (!variants || !buttons || variants.parentNode !== buttons.parentNode) return;
    var intro = null, p = variants.previousElementSibling;
    while (p) { if (p.classList.contains('product__text')) { intro = p; break; } if (p.classList.contains('product__head')) break; p = p.previousElementSibling; }
    var gift = blockOf(document.querySelector('.product__block .cr-gift'));
    if (gift && gift.parentNode !== buttons.parentNode) gift = null;
    if (mq.matches) {
      if (marks.length) return;
      [gift, intro].forEach(function(b){ if (!b) return; var m = document.createComment('cr-pos'); b.parentNode.insertBefore(m, b); marks.push([m, b]); });
      var after = buttons;
      [gift, intro].forEach(function(b){ if (!b) return; after.parentNode.insertBefore(b, after.nextSibling); after = b; });
    } else if (marks.length) {
      marks.forEach(function(pair){ pair[0].parentNode.insertBefore(pair[1], pair[0]); pair[0].remove(); });
      marks = [];
    }
  }
  function init(){ setTimeout(apply, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (mq.addEventListener) mq.addEventListener('change', apply);
})();
